import React from "react";
import { Link } from "react-router-dom";
import tools from "../../../helpers/tools";
import { WEB_URL } from "../../../config";
import {
  FORMULES,
  getStatus,
  getVehicleLabel,
} from "../Forms/autoRequestLabels";
import GreyCard from "./GreyCard";
// Badges de statut et méta partagés avec la page « Demandes en cours » : on
// importe sa feuille plutôt que de redéfinir les mêmes classes (webpack ne
// l'inclut qu'une fois, quel que soit le nombre d'écrans qui l'importent).
import "../Forms/AUTOContainer.scss";
import "./AUTORequestsSummary.scss";

// Cadre « Mes demandes d'assurance auto » de l'accueil du particulier (PER-2208).
// Résumé : une ligne par demande, le détail (stepper, téléchargement du devis)
// reste sur la page « Demandes en cours ».
//
// `isLoading` / `hasError` : le cadre disparaît dans les deux cas. Sans cette
// garde, un Graal indisponible (503, tableau vide) afficherait « aucune demande »
// et pousserait à tort vers le tunnel de souscription.
const AUTORequestsSummary = ({ autoRequests, isLoading, hasError }) => {
  if (isLoading || hasError) return null;

  return (
    <GreyCard>
      <>
        <div className="d-flex align-items-start flex-row justify-content-between w-100 auto-summary-header">
          <strong className="text-primary auto-summary-title">
            Mes demandes d'Assurance Auto
          </strong>
          <i
            className="fa fa-car text-primary auto-summary-icon"
            aria-hidden="true"
          />
        </div>

        {autoRequests.length ? (
          <div className="mt-2">
            {autoRequests.map((request) => {
              const status = getStatus(request.status);
              const vehicle = getVehicleLabel(request.vehicle);
              const immatriculation = request.vehicle?.registrationNumber;
              const titre = [vehicle || "Votre véhicule", immatriculation]
                .filter(Boolean)
                .join(" · ");
              const formule = FORMULES[request.formula];

              return (
                <div className="auto-summary-row" key={request.id}>
                  <div>
                    <strong style={{ fontSize: "var(--fs-16)" }}>{titre}</strong>
                    {formule && <p className="mb-0">Formule {formule}</p>}
                    <p className="auto-meta mb-0">
                      Demandée le {tools.formatDate(request.requestedAt)}
                    </p>
                  </div>
                  <div className="auto-summary-side">
                    <span className={`auto-badge ${status.badge}`}>
                      {status.label}
                    </span>
                    <Link className="auto-summary-link" to="/forms">
                      {request.quoteAvailable
                        ? "Voir mon devis"
                        : "Suivre ma demande"}
                      <i className="fa fa-arrow-right ml-2" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="mt-2">
            <p className="mb-3">
              Vous n'avez aucune demande d'assurance auto en cours.
            </p>
            <a
              className="btn btn-success text-white auto-summary-cta"
              style={{ minHeight: 44 }}
              href={`${WEB_URL}assurance-auto`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Découvrir l'Assurance Auto
            </a>
          </div>
        )}
      </>
    </GreyCard>
  );
};

export default AUTORequestsSummary;
